/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Open_EditorInputs */

const en_gc_resources_open_editor = /** @type {(inputs: Gc_Resources_Open_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the editor`)
};

const zh_gc_resources_open_editor = /** @type {(inputs: Gc_Resources_Open_EditorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开编辑器`)
};

/**
* | output |
* | --- |
* | "Open the editor" |
*
* @param {Gc_Resources_Open_EditorInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_open_editor = /** @type {((inputs?: Gc_Resources_Open_EditorInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Open_EditorInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_open_editor(inputs)
	return zh_gc_resources_open_editor(inputs)
});
export { gc_resources_open_editor as "gc.resources.open_editor" }